const helloAndGoodbye = {
  roleplayId: "nualang.hello-goodbye.0.0.1",
  roleplayName: "Hallo und auf Wiedersehen",
  description: "Lerne Hallo zu sagen und auf Wiedersehen",
  difficulty: "ALL",
  learnLang: "german",
  picture: "",
  actor1: {
    name: "Kasper",
    voice: "Kasper",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNS5wbmcifQ==",
  },
  actor2: {
    name: "Vicki",
    voice: "Vicki",
    picture:
      "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMy5wbmcifQ==",
  },
  script: [
    { text: "Hallo. Wie geht es dir?", actor: 1 },
    {
      text: "Mir geht es gut. Danke für die Frage. Wie geht es Ihnen?",
      actor: 2,
    },
    {
      text: "Ich kann mich nicht beklagen, das Leben behandelt mich gut.",
      actor: 1,
    },
    { text: "Das ist gut zu hören.", actor: 2 },
    {
      text: "Schön, Sie wiederzusehen, ich muss zum Termin meines Arztes.",
      actor: 1,
    },
    { text: "Schön dich zu sehen.", actor: 2 },
    { text: "Bis später.", actor: 1 },
  ],
};

export default helloAndGoodbye;
